import { V } from "./Vector.js";
export { ChannelPath };
class ChannelPath {
    constructor({ startPoint, arcs, endPoint, pathString, length }) {
        this.startPoint = startPoint;
        this.arcs = arcs;
        this.endPoint = endPoint;
        this.pathString = pathString !== null && pathString !== void 0 ? pathString : ChannelPath.pathString({ startPoint, endPoint, arcs });
        this.length = length !== null && length !== void 0 ? length : ChannelPath.pathLength({ startPoint, endPoint, arcs });
    }
    static pathString({ startPoint, endPoint, arcs }) {
        const path = arcs.reduce((a, c) => ({ s: V.equals(a.p, c.startPoint) ? (a.s + c.pathString()) : (a.s + `L ${c.startPoint[0]} ${c.startPoint[1]}` + c.pathString()), p: c.endPoint }), { s: `M ${startPoint[0]} ${startPoint[1]}`, p: startPoint });
        return V.equals(path.p, endPoint) ? path.s : path.s + `L ${endPoint[0]} ${endPoint[1]}`;
    }
    static pathLength({ startPoint, endPoint, arcs }) {
        const sum = arcs.reduce((acc, current) => {
            return {
                last: current.endPoint,
                length: acc.length + V.distance(current.startPoint, acc.last) + current.length
            };
        }, { last: startPoint, length: 0 });
        const lastPart = arcs.length === 0 ? V.distance(startPoint, endPoint) : V.distance(endPoint, arcs[arcs.length - 1].endPoint);
        return sum.length + lastPart;
    }
}
//# sourceMappingURL=ChannelPath.js.map